



































































































import { Vue, Component } from 'vue-property-decorator';

import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import BasicModal from '@/components/Molecules/Modal/BasicModal.vue';
import ModalTextLink from '@/components/Atoms/Link/ModalTextLink.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';
import CheckBox from '@/components/Atoms/Input/CheckBox.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';

@Component({
  components: {
    ModalTextLink,
    BasicModal,
    RadioButton,
    TextLink,
    CheckBox,
    UnorderedList,
    ListItem,
  },
})
export default class EntryType extends Vue {
  public entryTypeList: string[] = ['new', 'flets', 'other']; // 光回線再利用の選択肢一時停止対応 'reuse'の選択肢を削除 戻す場合は再度、リストに最後尾に追加
  public currentUsageTypeList: { id: string; value: string; text: string }[] = [
    {
      id: 'currentUsageType_1g',
      value: '1g',
      text: '1ギガ以下タイプ',
    },
    {
      id: 'currentUsageType_10g',
      value: '10g',
      text: '10ギガタイプ',
    },
  ];

  get entryType() {
    return this.$store.getters['hikari/entryType'];
  }

  get currentUsageType() {
    return this.$store.getters['hikari/currentUsageType'];
  }

  fletsOrOther(id: string): boolean {
    return ['flets', 'other'].includes(id);
  }

  other(id: string): boolean {
    return 'other' === id;
  }

  bracketedSentence(id: string): string {
    let s = '';
    if (this.other(id)) {
      s =
        '(ギガファミリー・スマートタイプまたはギガマンション・スマートタイプに相当する回線をご利⽤の⽅)';
    } else {
      s =
        '(ギガファミリー・スマートタイプまたはギガマンション・スマートタイプご利⽤の⽅)';
    }
    return s;
  }
}
